import RequestsHook, { APIResponse, CityResponseData } from '@interfaces/requests.interfaces';
import { getAccessToken } from '@auth/keycloak';
import Axios, { Method } from 'axios';

function useRequests(): RequestsHook {
	async function resolveToken(): Promise<string | null> {
		return getAccessToken();
	}

	async function request<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		const token = await resolveToken();
		const response = await Axios({
			method,
			url: `${process.env.REACT_APP_APIV2_URL}/${url}`,
			data,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data as APIResponse<Response>;
	}

	async function requestAdministraCliente<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		const token = await resolveToken();
		const response = await Axios({
			method,
			url: `${process.env.REACT_APP_API_ADMINISTRA_CLIENTE}/${url}`,
			data,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data as APIResponse<Response>;
	}

	async function requestBackendSuite<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		const token = await resolveToken();
		const response = await Axios({
			method,
			url: `${process.env.REACT_APP_API_SUITE_BACKEND_SERVICE}/${url}`,
			data,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data as APIResponse<Response>;
	}

	async function requestAutorizaciones<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		const token = await resolveToken();
		const response = await Axios({
			method,
			url: `${process.env.REACT_APP_API_AUTORIZACIONES_URL}/${url}`,
			data,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data as APIResponse<Response>;
	}

	async function requestCity(codigo: string): Promise<CityResponseData> {
		const response = await Axios.get(
			`${process.env.REACT_APP_APIV2_URL}/mantenimiento-operativo/consulta-mantenimiento-operativo/ciudad/${codigo}`
		);

		return response.data.data;
	}

	async function requestGeneracionGuia<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		return request<Response, Data>(`requestGeneracionGuia/${url}`, method, data);
	}

	async function requestCombos<Response, Data = undefined>(
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		const response = await request<Response, Data>(
			`mantenimiento-operativo/maestro-combos-suite/combos`,
			method,
			data
		);
		return response;
	}

	async function requestMantenimientoOperativo<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		return request<Response, Data>(
			`mantenimiento-operativo/consulta-mantenimiento-operativo/${url}`,
			method,
			data
		);
	}

	async function requestNivelesDeServicio<Response, Data = undefined>(
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		return requestBackendSuite<Response, Data>(`sifa/niveles-servicios`, method, data);
	}

	async function requestSuite<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		return request<Response, Data>(`suite-logistica/${url}`, method, data);
	}

	async function requestTest<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		const token = await resolveToken();
		const response = await Axios({
			method,
			url: `https://apiv2-test.coordinadora.com/${url}`,
			data,
			headers: {
				// Legacy Node/test backends that expect raw token (no Bearer prefix)
				Authorization: `${token}`,
			},
		});

		return response.data as APIResponse<Response>;
	}

	async function requestNodeRed<Response, Data = undefined>(
		url: string,
		method: Method = 'GET',
		data?: Data
	): Promise<APIResponse<Response>> {
		const token = await resolveToken();
		const response = await Axios({
			method,
			url: `${process.env.REACT_APP_API_NODERED}/${url}`,
			data,
			headers: {
				// Legacy NodeRed expects raw token (no Bearer prefix)
				Authorization: `${token}`,
			},
		});

		return response.data as APIResponse<Response>;
	}

	return {
		requestTest,
		request,
		requestCity,
		requestGeneracionGuia,
		requestMantenimientoOperativo,
		requestSuite,
		requestCombos,
		requestNivelesDeServicio,
		requestAdministraCliente,
		requestAutorizaciones,
		requestBackendSuite,
		requestNodeRed,
	};
}

export default useRequests;
